import type { Customer } from '@/services/db/customer/entity';
import type { CustomerSearchQuery } from '@/services/db/customer/merge';

/** At most this many matches are offered for selection. */
export const SEARCH_RESULTS_CUTOFF = 10;

/** The matches minus the people already selected in either card, capped for display. */
export function selectableMatches(matches: readonly Customer[], selected: ReadonlyArray<Customer | null>) {
  const selectedIds = selected.flatMap((customer) => (customer == null ? [] : [customer.id]));
  const selectable = matches.filter((customer) => !selectedIds.includes(customer.id));
  return { matches: selectable.slice(0, SEARCH_RESULTS_CUTOFF), matchCount: selectable.length };
}

/** The "Merge: Person Searched" event's properties for a query with `matchCount` selectable matches. */
export function searchedEventProperties(query: CustomerSearchQuery, matchCount: number) {
  return {
    'Filtered by Email Address': 'email' in query,
    'Filtered by Profile ID': 'id' in query,
    'Filtered by Attribute Condition': 'filters' in query,
    'More than Ten Matches': matchCount > SEARCH_RESULTS_CUTOFF,
  };
}
